// extracted by mini-css-extract-plugin
export default {"button":"Y0jijD4DeJ0GTFmcTawL"};